import actions from 'actions/profiles'
import authActions from 'actions/auth'
import locationActions from 'actions/locations'
import userGroupActions from 'actions/userGroups'
import supplierActions from 'actions/suppliers'
import customerActions from 'actions/customers'
import userActions from 'actions/users'
import { createFormViewContainer } from 'factories/FormView'
import Component from 'components/Profiles/FormView'

export default createFormViewContainer({
  actions,
  extraDispatchToProps: (dispatch, props) => ({
    newItem: (params) => dispatch(actions.newItem(params)),
    refreshToken: (params) => dispatch(authActions.refreshToken(params)),
    getUsers: (params) => dispatch(userActions.getItems(params)),
    getLocations: (params) =>
      dispatch(locationActions.getItems({ ...params, locationVendingTypes: ['NonVending'] })),
    getSuppliers: (params) => dispatch(supplierActions.getOptions({ ...params, active: 'Active' })),
    getCustomers: (params) => dispatch(customerActions.getOptions(params)),
    getUserGroups: (params) => dispatch(userGroupActions.getOptions(params)),
  }),
})(Component)
